import {GetRefundBanksParams} from 'domain/usecases/private/refund/request/get-banks';
import {makeGetRefundBanks} from 'main/factories/usecases/private/refund/request/get-banks';

export async function getRefundBanks(params: GetRefundBanksParams) {
	const response = await makeGetRefundBanks().get(params);

	return response?.content?.banks ?? [];
}
